(ns dashboard.entity.evidence.fields
  (:require [clojure.string :as str]
            [dashboard.common :as common]
            [dashboard.components.popup-menu :as popup]
            [dashboard.components.radiobox :as radiobox]
            [dashboard.entity.analysis.profile :as analysis.profile]
            [dashboard.entity.organization.profile :as org.components]
            ["react" :as react]))

(defn ControlStatus
  [{:keys [mode state-evidence validation-error set-field]}]
  (assert (fn? set-field))
  [analysis.profile/subfield
   "Control Status"
   [:f> radiobox/radiobox
    {:options ["Met"
               "Partially Met"
               "Not Met"]
     :value (:control-status state-evidence)
     :disabled (false? (:is-valid state-evidence))
     :on-set-value (fn [value]
                     (set-field :control-status value))
     :validation-error (first (:control-status validation-error))
     :editable? (= :edit mode)
     :title "Control Status"}]])

(defn Information
  [{:keys [mode state-evidence validation-error set-field]}]
  (assert (fn? set-field))
  [analysis.profile/subfield
   "Information"
   [:f> radiobox/radiobox
    ;; TODO: Figure out hardcoded options.
    ;; TODO: Provide options from existing applied analyses, but maybe from same category only
    {:options ["Client"
               "Technical Infrastructure Configuration"
               "Service Configuration Document"
               "Public Policy Document"
               "Internal Policy Document"
               "Legal Document"
               "Attestation document"]
     :disabled (false? (:is-valid state-evidence))
     :value (:information-type state-evidence)
     :on-set-value #(set-field :information-type %)
     :validation-error (first (:information validation-error))
     :editable? (= :edit mode)
     :title "The type of information of the source"}]])

(defn DirectlyResponsibleIndividual
  [{:keys [mode
           state-evidence
           set-field
           form-errors
           save-person
           organization-view]}
   organization-members]
  (assert (fn? set-field))
  (let [[modal-instance set-modal-instance] (react/useState 1)
        dri-person-id (:responsible-person-id state-evidence)
        dri-person (->> organization-members
                        (filter (comp (partial = dri-person-id) :person-id))
                        first)
        form-errors form-errors
        after-save (fn [new-person]

                     (set-field :responsible-person-id
                                (:person-id new-person))
                     (set-field :responsible-person-revision
                                (:revision new-person))
                     (set-modal-instance inc))
        on-submit (fn [base-map e]
                    (.preventDefault e)
                    (save-person
                     (assoc base-map :create-new true)
                     after-save
                     true))]
    (if (= :edit mode)
      [:div.level.applied-structures-analysis-dri-person
       [:div.level-left
        [org.components/member-select
         (into [{:fullname "-- Select a Person --"
                 :value -1}]
               organization-members)
         #{0}
         (js/parseInt dri-person-id)
         (fn [value]
           (set-field :responsible-person-id
                      (when-not (= -1 value) value))
           (set-field :responsible-person-revision
                      (->> organization-members
                           (filter #(= (:person-id %) value))
                           first
                           :revision)))
         (or (false? (:is-valid state-evidence))
             (not= :edit mode))]
        [:div.ml-2
         [:f> popup/popup-menu
          {:trigger-content "+"
           :suspend-click-to-close true
           :modal-instance modal-instance
           :disabled (false? (:is-valid state-evidence))
           :content [:f> org.components/member-profile
                     {:reports-to-person-id 0
                      :prevent-navigate-on-save true
                      :abbridged-form true
                      :on-close #(set-modal-instance inc)}
                     on-submit
                     organization-members
                     form-errors
                     nil
                     identity
                     organization-view]}]]]]

      (let [{:keys [fullname
                    title]} (->> organization-members
                                 (filter (comp (partial = dri-person-id)
                                               :person-id))
                                 first)]
        (if dri-person
          [:<>
           (:fullname dri-person)
           (when (seq (:title dri-person)) " - ")
           (:title dri-person)
           (when-not (or (nil? dri-person)
                         (nil? fullname)
                         (and (= fullname (:fullname dri-person))
                              (= title (:title dri-person))))
             [:<>
              " (Currently: "
              fullname
              (when (seq title) " - ")
              title
              ")"])]
          "<< Not Specified >>")))))

(defn Provider
  [{:keys [mode state-evidence validation-error set-field]}]
  (assert (fn? set-field))
  [analysis.profile/subfield
   "Provider"
   [:f> radiobox/radiobox
    ;; TODO: Figure out hardcoded options.
    ;; TODO: Provide options from existing applied analyses, but maybe from same category only
    {:options ["Client" "Latacora"]
     :value (:provider state-evidence)
     :disabled (false? (:is-valid state-evidence))
     :on-set-value #(set-field :provider %)
     :validation-error (first (:provider validation-error))
     :editable? (= :edit mode)
     :title "The provider of the validation information source"}]])

(defn ValidatedByAutomation
  [{:keys [mode state-evidence set-field]}]
  (assert (fn? set-field))
  [analysis.profile/subfield
   "Validated by automation"
   [:div.field-body
    [:div.field.has-addons
     [:div.control.is-expanded
      [:input.input
       {:title "Specifies the automation that validates this control"
        :disabled (or (false? (:is-valid state-evidence))
                      (not= :edit mode))
        :auto-complete "sjs-automation"
        :name "sjs-automation"
        :value (:validated-by-automation state-evidence)
        :on-change (fn [e]
                     (set-field :validated-by-automation (.. e -target -value)))}]]
     (when (= :edit mode)
       [:div.control
        [:button.button
         [:span.icon.is-small.is-right
          {:on-click #(set-field :validated-by-automation nil)}
          [:i.fas.fa-xmark]]]])]]])

(defn Reference
  [{:keys [mode
           state-evidence
           references
           set-field]}
   reference-completions
   set-reference-completions
   selected-completion-index
   set-selected-completion-index
   option-idx->element-atom
   dropdown-content-ref
   set-dropdown-content-ref]

  (assert (fn? set-field))
  [analysis.profile/subfield
   "Reference"
   [:div.field-body
    [:div.control.is-expanded.is-flex-grow-1
     [:div.dropdown
      {:style {:width "100%"}
       :class (when (seq reference-completions) "is-active")}
      [:div.dropdown-trigger
       {:style {:width "100%"}}
       [:input.input
        {:title "The location inside the information, used for validation"
         :disabled (or (false? (:is-valid state-evidence))
                       (not= :edit mode))
         :type "text"
         :auto-complete "sjs-reference"
         :placeholder (when (= :edit mode)
                        "For example: page 8, paragraph 3 ")
         :value (:reference state-evidence)
         :on-change (fn [e]
                      (let [value (.. e -target -value)]
                        (if (str/blank? value)
                          (do
                            (set-reference-completions references)
                            (set-selected-completion-index nil))
                          (let [value (str/lower-case value)
                                completions (filter #(str/starts-with? (str/lower-case %) value) references)]
                            (set-reference-completions completions)
                            (when (or (= 1 (count completions))
                                      (not selected-completion-index))
                              (set-selected-completion-index 0))))
                        (set-field :reference value)))
         :on-click (fn [e]
                     (let [value (.. e -target -value)]
                       (when (str/blank? value)
                         (set-reference-completions references)
                         (set-selected-completion-index nil))))
         :on-key-down (fn [e]
                        (let [key-down (.-key e)]
                          (letfn [(select-option [selection-index]
                                    (set-selected-completion-index selection-index)
                                    ;; If there are a lot of options, we make sure the selected option is visible,
                                    ;; by scrolling the content so that it covers the selected element (and a bit extra)
                                    (when-let [element (@option-idx->element-atom selection-index)]
                                      (when dropdown-content-ref
                                        (.scroll dropdown-content-ref 0 (- (.-offsetTop element) 50)))))]
                            (case key-down
                              "Escape" (set-reference-completions [])
                              "ArrowDown" (select-option (min (inc (or selected-completion-index -1))
                                                              (dec (count reference-completions))))
                              "ArrowUp" (select-option (max 0
                                                            (dec (or selected-completion-index 0))))
                              "Enter" (when-let [reference-completion (first (keep-indexed (fn [option-idx reference-completion]
                                                                                             (when (= selected-completion-index option-idx)
                                                                                               reference-completion))
                                                                                           reference-completions))]
                                        (set-field :reference reference-completion)
                                        (set-reference-completions [])
                                        (set-selected-completion-index nil))
                              nil))))}]]
      [:div.dropdown-menu {:role "menu"}
       [:div.dropdown-content
        {:style {:max-height "15em"
                 :overflow "auto"
                 :max-width "650px"}
         :ref set-dropdown-content-ref}
        (map-indexed (fn [option-idx reference-completion]
                       [:a.dropdown-item
                        {:key reference-completion
                         :style {:border (when (= option-idx selected-completion-index)
                                           "solid 1px blue")
                                 :width "100%"}
                         :ref #(swap! option-idx->element-atom (fn [option-idx->element]
                                                                 (if %
                                                                   (assoc option-idx->element option-idx %)
                                                                   (dissoc option-idx->element option-idx))))
                         :tab-index 0
                         :on-click (fn [_]
                                     (set-field :reference reference-completion)
                                     (set-reference-completions []))
                         :on-key-down (fn [e]
                                        (let [key-down (.-key e)]
                                          (when (#{" " "Enter"} key-down)
                                            (set-field :reference reference-completion)
                                            (set-reference-completions []))))
                         :on-focus (fn [_]
                                     (set-selected-completion-index nil))}
                        reference-completion])
                     reference-completions)]]]]]])

(defn Responsibility
  [{:keys [mode state-evidence set-field]
    :as props}
   organization-members]
  (assert (fn? set-field))
  [analysis.profile/subfield
   "Responsible Owner"
   [:div.field-body.p-4
    {:style {:border-radius "6px"
             :border "0.1em solid"
             :border-color "#DBDBDB"
             :padding "8px"
             :flex-direction :column}}
    [analysis.profile/subfield
     "Organization"
     [:input.input
      {:title "The organization responsible for the control"
       :disabled (or (false? (:is-valid state-evidence))
                     (not= :edit mode))
       :auto-complete "dri-organization"
       :type "text"
       :value (:responsible-org state-evidence)
       :on-change (fn [e]
                    (set-field :responsible-org
                               (.. e -target -value)))}]]
    [analysis.profile/subfield
     "Team"
     [:input.input
      {:title "The team within the organization responsible for the control"
       :disabled (or (false? (:is-valid state-evidence))
                     (not= :edit mode))
       :auto-complete "dri-team"
       :type "text"
       :value (:responsible-team state-evidence)
       :on-change (fn [e]
                    (set-field :responsible-team
                               (.. e -target -value)))}]]
    [analysis.profile/subfield
     "Directly Responsible Individual"
     [:f> DirectlyResponsibleIndividual
      props
      organization-members]]]])

(defn Expiration
  [{:keys [mode
           state-evidence
           set-field]}]
  (assert (fn? set-field))
  (let [has-date (not (and (= :edit mode)
                           (str/blank? (:expiry-date state-evidence))))]
   [analysis.profile/subfield
   "Information Expiration Date"
   [:div.field-body
    [:div.field.is-horizontal
     [:div.field-label.is-normal
      [:label.label "Date"]]
     [:div.field-body
      [:input.input
       {:type :date
        :min (subs (.toISOString (js/Date. (.now js/Date))) 0 10)
        :disabled (or (false? (:is-valid state-evidence))
                      (not= :edit mode))
        :value (some-> state-evidence
                       :expiry-date
                       common/format-date->input)
        :on-change (fn [e]
                     (set-field :expiry-date
                                (common/format-input->date e.target.value)))}]]
     [:div.field-label.is-normal
      {:style {:margin-left "24px"}}
      [:label.label "Action"]]
     [:input.input
      {:title "Action to be taken once information has expired"
       :auto-complete "sjs-expiry-action"
       :disabled (or (false? (:is-valid state-evidence))
                     (not= :edit mode)
                     (not has-date))
       :type "text"
       :value (when has-date
                (if (str/blank? (:expiry-action state-evidence))
                  "Review"
                  (:expiry-action state-evidence)))
       :on-change (fn [e]
                    (set-field :expiry-action
                               (.. e -target -value)))}]]]]))

(defn Comment
  [{:keys [mode state-evidence set-field]}]
  (let [[ref set-ref] (react/useState nil)]
    (react/useEffect
     (fn []
      (when ref
       (aset (.-style ref)
           "height"
           (str (+ (.-scrollHeight ref) 4)
                "px")))))

    [analysis.profile/subfield
     "Comment"
     [:textarea.input
      {:disabled (or (false? (:is-valid state-evidence))
                     (not= :edit mode))
       :ref set-ref
       :on-input (fn [e]
                   (let [elem (.-target e)]
                     (aset (.-style elem)
                           "height"
                           "0")
                     (aset (.-style elem)
                           "height"
                           (str (- (.-scrollHeight elem) 4) "px"))))
       :type "text"
       :auto-complete "sjs-comment"
       :value (:comment state-evidence)
       :placeholder (when (= :edit mode) "Comment...")
       :on-change (fn [e]
                    (set-field :comment
                               (.. e -target -value)))}]]))

(defn Header
  [idx mode on-remove-source is-valid]
  [:div.field.is-horizontal.my-0
   [:div.title.is-5.my-0
    [:i.icon.fas.fa-bookmark.fa-regular.mr-2]
    "Source " (inc idx)]

   [:div.my-0.field-body.level-right
    (when (false? is-valid)
      [:div.notification.is-warning.my-0.py-0.mx-6.px-6
       [:b
        [:i.icon.fas.fa-triangle-exclamation.mr-2]
        "Invalid Evidence"]])
    (when-not (= :view mode)
      [:button.button
       {:on-click (fn [_]

                    (when (js/confirm (str "Delete Validation Information Source #"
                                           (inc idx)))
                      (on-remove-source idx)))}
       [:span.icon>i.fas.fa-xmark]])]])





